import { easeInOutCubic } from "../utils/dom";
import jump from "jump.js";

export function ScrollCue() {
  var cue = document.getElementsByClassName("scrollCue");
  var cueEnd = document.getElementById("scrollCueEnd");
  ScrollToLocation(cue, cueEnd);
}

export function ScrollToLocation(cue: HTMLCollectionOf<Element>, cueEnd: HTMLElement) {
  if (!cue.length) return;

  cue[0].addEventListener("click", () => {
    jump(cueEnd || window.innerHeight, {
      duration: 600,
      offset: -81,
      easing: easeInOutCubic,
    });
  });
}
